import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import { clearSpinner, setSpinner } from '../../app_store/actions/spinner';
import {
    downloadLOExportSampleCsv,
    updateAccountLabResultStatus,
} from '../../services/account.service';
import MessageContainer from '../message.component';

const ResultDistConfiguration = props => {
    const { id: accountId } = useParams();
    const [message, setMessage] = useState({});

    const [exportLabResults, setExportLabResults] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (props.accData) {
            setValue(
                'is_enabled_res_export',
                props.accData?.is_enabled_res_export,
            );
            setValue('result_dist_email', props.accData?.result_dist_email);
            if (props.accData?.is_enabled_res_export) {
                setExportLabResults(true);
            }
        }
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            is_enabled_res_export: false,
            result_dist_email: '',
        },
    });
    const handleResultSettings = async formData => {
        setLoading(true);
        try {
            const lab_result_status = {
                is_enabled_res_export: formData?.is_enabled_res_export
                    ? formData.is_enabled_res_export
                    : false,
                result_dist_email: formData?.result_dist_email,
            };
            await updateAccountLabResultStatus(accountId, lab_result_status);

            setMessage({
                type: 'Success',
                message: 'Changes have been saved successfully',
            });
            // reload account data
            props.fetchAccDetails();
        } catch (error) {
            if (error.response.status === 400) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            } else {
                setMessage({
                    type: 'Error',
                    message: 'Changes not saved try again',
                });
            }
        }
        setLoading(false);
    };
    const downloadLOSampleCSV = async e => {
        e.preventDefault();
        dispatch(setSpinner());
        try {
            const resp = await downloadLOExportSampleCsv();
            const blob = new Blob([resp], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('href', url);
            a.setAttribute('download', 'laborder_export_sample.csv');
            a.click();
        } catch (error) {
            setMessage({ message: 'Error in downloading csv', type: 'Error' });
        }
        dispatch(clearSpinner());
    };

    return (
        <>
            {message && <MessageContainer message={message} />}
            <div className="new-line"></div>
            <form
                className="row g-2"
                onSubmit={handleSubmit(handleResultSettings)}>
                <div className="form-check col-md-12">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="exportLabResults"
                        {...register('is_enabled_res_export', {
                            required: false,
                        })}
                        onChange={e => {
                            setExportLabResults(e.target.checked);
                        }}
                    />
                    <label
                        className="form-check-label"
                        style={{ cursor: 'pointer' }}>
                        Enable lab results weekly export (every Friday 8AM CST)
                        [
                        <Link onClick={downloadLOSampleCSV} to="#">
                            download sample file
                        </Link>
                        ]
                    </label>
                </div>
                <div className="form-check col-md-12">
                    <label
                        className="form-check-label"
                        style={{ cursor: 'pointer' }}
                        htmlFor="email">
                        Result delivery email (Result will be distributed via
                        email as csv file attachment)
                    </label>

                    <input
                        type="email"
                        className={
                            errors?.result_dist_email
                                ? 'form-control is-invalid'
                                : 'form-control'
                        }
                        id="result_dist_email"
                        disabled={!exportLabResults}
                        style={{
                            width: '300px',
                            marginTop: '5px',
                            marginBottom: '5px',
                        }}
                        placeholder="Result delivery email"
                        {...register('result_dist_email', {
                            required: false,
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: 'invalid email address',
                            },
                        })}
                    />
                    {errors && (
                        <div className="invalid-feedback">
                            {errors.result_dist_email?.message}
                        </div>
                    )}
                </div>
                <div className="form-check col-md-12">
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}>
                        {loading && (
                            <span className="spinner-border spinner-border-sm"></span>
                        )}
                        Apply Configuration
                    </button>
                </div>
            </form>
        </>
    );
};

export default ResultDistConfiguration;
